module.exports = __webpack_public_path__ + "img/Stab_BÖH.d62c610c.svg";